import { useQuery } from '@tanstack/react-query';

import {
  fetchPublishedTerm,
  fetchPublishedTermsList,
  fetchStaffTermsList,
  type PublishedTerm,
  type PublishedTermSummary,
  type StaffTermSummary,
} from '@/api/adapters/terms-policies';

export const TERMS_LIST_QUERY_KEY = ['terms', 'list'] as const;

// Public list (no per-user state) — used by pre-login signup.
export function useTermsList() {
  return useQuery<PublishedTermSummary[]>({
    queryKey: TERMS_LIST_QUERY_KEY,
    queryFn: fetchPublishedTermsList,
    staleTime: 60_000,
  });
}

export const MY_TERMS_LIST_QUERY_KEY = ['terms', 'me', 'list'] as const;

// The logged-in staff's list, each row carrying `agreed` — used by the /settings page.
export function useStaffTermsList() {
  return useQuery<StaffTermSummary[]>({
    queryKey: MY_TERMS_LIST_QUERY_KEY,
    queryFn: fetchStaffTermsList,
    staleTime: 60_000,
  });
}

export const termDetailQueryKey = (typeId: number) =>
  ['terms', 'detail', typeId] as const;

export function useTerm(typeId: number | null) {
  return useQuery<PublishedTerm>({
    queryKey:
      typeId !== null ? termDetailQueryKey(typeId) : ['terms', 'detail', null],
    queryFn: () => fetchPublishedTerm(typeId as number),
    enabled: typeId !== null,
    staleTime: 60_000,
  });
}
